<template>
    <div>
        <b-row class="align-items-center">
            <b-col cols="6">
                <b-button variant="link" @click="emitEvent('go-back-to-chat-main')" class="px-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6L14 18Z"/></svg>
                    Back
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <h3 class="font-weight-500">Create Private Message With</h3>
            </b-col>
        </b-row>
        <b-form role="form" @submit.prevent="createGroup">
            <b-row>
                <!-- <b-col cols="12">
                    <b-form-group>
                        <b-form-radio-group
                            v-model="new_group.type"
                            :options="typeOptions"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col> -->
                <b-col cols="12">
                    <b-form-group label="Add Participants">
                        <el-select
                            v-model="selected_user_id"
                            filterable
                            placeholder="Please enter a keyword">
                            <el-option-group
															v-for="(group,index) in userListOpt"
                                :key="index"
															:label="group.group_name">
															<el-option
																v-for="(item, idx) in group.group_items"
																:key="idx"
																:label="item.name"
																:value="item.id">
                            </el-option>
														</el-option-group>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" class="text-center">
                    <b-button type="submit" variant="primary" class="py-2 px-5 mt-5">Create Private Chat</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
<script>
import { Select, Option, OptionGroup } from 'element-ui'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
    props: {
        showCreatNewGroup: Boolean,
        showMainPage: Boolean,
        showChatRooms: Boolean,
    },
    components: {
				[OptionGroup.name]: OptionGroup,
        [Option.name]: Option,
        [Select.name]: Select,
    },
    data(){
        return {
					selected_user_id:null
        }
    },
    computed: {
      ...mapState(useMessagingStore, ['selected_group', 'available_user_list']),
			userListOpt(){
				let items = this.available_user_list.filter(o => o.id != _gAuth.activeUserId());
				let grouped = _.groupBy(items,'corporate_name');
				return Object.keys(grouped).map(label => ({
						group_name: label,
						group_items: grouped[label]
				}));
			}
    },
		created() {
			this.resetData()
		},
		mounted() {
			this.resetData()
		},
		methods: {
			...mapActions(useMessagingStore,['createGroupMessage','getNewBundleKey']),
			emitEvent(eventName) {
				chatEventBus.$emit(eventName);
			},
			async createGroup() {
					if(_gHlp.isEmpty(this.selected_user_id) || (this.selected_user_id == _gAuth.activeUserId())){
						_gNotif.notifyError('Please select user first')
						return false;
					}
					let selected_id = this.selected_user_id;
					const selectedUser = this.available_user_list.find(user => user.id === selected_id)
					if(_gHlp.isEmpty(selectedUser)){
						_gNotif.notifyError('Please select user first')
						return false;
					}

					let group_participants = [];
					// ADD OPONENT ID
					group_participants.push({
							participant_user_id: selectedUser.id,
							participant_username: selectedUser.name,
							participant_fullname: selectedUser.name,
							participant_photo_profile: null,
					});

					//ADD MY ID
					const activeUser = _gAuth.activeUser()
					group_participants.push({
						participant_user_id: activeUser.id,
						participant_username: activeUser.name,
						participant_fullname: activeUser.name,
						participant_photo_profile: null,
					});
				
					let group_type = (selectedUser.corporate_id == _gAuth.activeCorporateId()) ? 'internal' : 'external';
				
					const postData = {
							group_name: 'PRIVATE: '+ selectedUser.name + ' and '+ activeUser.name,
							group_type: group_type,
							group_channel_type: 'PRIVATE',
							group_bundle_key: this.getNewBundleKey(),
							group_participants: group_participants
					}
					
					let status = await this.createGroupMessage(postData)
					if(status){
						this.resetData();
						this.emitEvent('show-chats-room', this.selected_group)
					}
			},
			resetData() {
				this.selected_user_id = null;
			},
    },
}
</script>